import Message from 'ant-design-vue/lib/message';
import 'ant-design-vue/lib/message/style/css';
import store from "@/store/index"
import router from "@/router/index"
const fun = (apiName, arg, cb) => {
  apiName(arg).then(res => {
    if (res.code === 200) {
      cb(res)
      //token验证到期时      //多人登录时
    } else if (res.code == 443||res.code == 428||res.code==475) {
      Message.error(res.message)
      localStorage.setItem("isLogin", 1);
      localStorage.setItem("role", "");
      localStorage.setItem("username", "");
      localStorage.setItem("icon", "");
      localStorage.setItem("token", "");
      localStorage.setItem("authentation", "");
      store.commit('clear')
      router.push({path:"/"})
      this.$socket.emit('logout','token多人登录')
      //登录时间超过10小时时
    } else if(res.code==427){
      localStorage.setItem("isLogin", 1);
      localStorage.setItem("role", "");
      localStorage.setItem("username", "");
      localStorage.setItem("icon", "");
      localStorage.setItem("token", "");
      localStorage.setItem("authentation", "");
      store.commit('clear')
      router.push({path:"/"})
      this.$socket.emit('logout','登录时间超时了')
    }
      else if(res.code==481){
      Message.error("视频还在审核中")
      // router.go(-1)
    }
    // else if((new Date().getTime()-localStorage.getItem("loginTime")>10*60*60*1000)){
    //   Message.error(res.message)
    //   localStorage.setItem("isLogin", 1);
    //   localStorage.setItem("role", "");
    //   localStorage.setItem("username", "");
    //   localStorage.setItem("icon", "");
    //   localStorage.setItem("token", "");
    //   localStorage.setItem("authentation", "");
    //   store.commit('clear')
    //   router.push({path:"/"})
    // }
    else {
      Message.error(res.message)
    }
  }).catch(() => {
    //Message.error('出错了')
  })
}
export default fun